import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { TError } from 'config/types'
import { getAppIdCookie } from 'utils/token'

// eslint-disable-next-line max-len
import { fetchSmmRequest } from 'containers/dashboard/features/cloud/components/tabs/smm/store/actions'

import Preloader from 'components/preloader/Preloader'
import { RootState } from 'redux/reducers/rootReducer'
import EmulatorEmpty from 'containers/emulator/components/emulator-empty/EmulatorEmpty'

import SmmView from './components/smm-view/SmmView'

const SmmPage = () => {
    const { t, i18n } = useTranslation(['toast'])
    const dispatch = useDispatch()

    const { smmDetails } = useSelector((state: RootState) => state.smm)

    const appId = getAppIdCookie()

    useEffect(() => {
        if (!appId) return
        dispatch(
            fetchSmmRequest({
                appId,
                language: i18n.language,
                callback: (type: string, errorArray?: TError[]) => {
                    if (type === 'error') {
                        errorArray?.forEach(err => {
                            console.error(err.description)
                            toast.error(t('toast:backendError'))
                        })
                    }
                },
            }),
        )
    }, [dispatch, appId, t, i18n.language])

    return smmDetails ? (
        smmDetails.length ? (
            <SmmView data={smmDetails} />
        ) : (
            <EmulatorEmpty />
        )
    ) : (
        <Preloader />
    )
}
export default SmmPage as React.FC
